var exports = {
  "M6": "x43aef4ae--68832c--slide",
  "Uw": "x43aef4ae--68832c--slide-content",
  "Sl": "x43aef4ae--68832c--image",
};

module.exports = exports;
